import { SortableContext } from "@dnd-kit/sortable";

import scrollStyles from "../../scss/scrollbar.module.scss";
import listStyles from "./listStyles.module.scss";
import { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { ANIMATION_DURATIONS } from "../../utils/consts";
import { useSelector } from "react-redux";

const DivAnimatronico = motion.create("div");

function sizeSelector(nCards) {
  if (nCards <= 4) return listStyles.sizeS4;
  else if (nCards <= 6) return listStyles.size56;
  else return listStyles.size7P;
}

export const SortableList = forwardRef(function SortableList(props, ref) {
  const { itemIds, strat, children } = props;

  const questions = useSelector((state) => state.game.questions);
  const currentQuestionIndex = useSelector((state) => state.game.currentIndex);
  const currentQuestion = questions[currentQuestionIndex];
  const listSize = currentQuestion.items.length;

  const itemNumber = useMemo(() => {
    return itemIds.length;
  }, [itemIds]);

  return (
    <DivAnimatronico
      ref={ref}
      transition={{ staggerChildren: ANIMATION_DURATIONS.cardSpawn }}
      className={clsx(
        listStyles.list,
        sizeSelector(listSize),
        scrollStyles.scrollbar,
        itemNumber > 8 && listStyles.pushBottom
      )}
    >
      <SortableContext items={itemIds} strategy={strat}>
        {children}
      </SortableContext>
    </DivAnimatronico>
  );
});
